import React from 'react';
import { RecallItems } from '../../../services/recalls-service/recalls-service';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { StringUtil } from '../../../components/utils/string-util/string-util';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
import './recalls-button.scss';
import arrowRight from '../../../assets/recalls-arrow.svg';
import errorIcon from '../../../assets/error-dark.svg';
interface Props {
    recall: RecallItems;
    content: RecallsUnitedContent;
    isCsp: boolean;
    exemptWordsList?: ExemptWordsListProps | null;
    onClick: (recall: RecallItems, showModal: boolean, isCsp: boolean) => void;
    isSelected?: boolean;
}
export const recallsToLowerCase = (
    sentence: string,
    exemptWordsList?: ExemptWordsListProps | null
) => {
    if (sentence)
        return exemptWordsList
            ? StringUtil.sentenceCase(sentence, exemptWordsList)
            : StringUtil.sentenceCaseWithoutSanitize(sentence);
    return '';
};
const RecallsButton = (props: Props) => {
    const { recall, content, isCsp, isSelected } = props;

    const handleOnClick = () => {
        props.onClick?.(recall, true, isCsp);
    };
    const checkForDoNotDrive = recall?.descriptionLang
        ?.toLowerCase()
        .includes(content.doNotDriveText?.toLowerCase());
    return (
        <button
            className={`recalls-info-button${
                isSelected ? ' current-recall' : ''
            }`}
            onClick={handleOnClick}
            aria-label={`${content.openRecallDetailsAriaLabel} ${recall.descriptionLang}`}
        >
            {checkForDoNotDrive && (
                <img
                    loading="lazy"
                    src={errorIcon}
                    alt=""
                    height={24}
                    width={24}
                />
            )}
            <div
                className={`${
                    checkForDoNotDrive
                        ? 'recalls-do-not-drive-info-button'
                        : 'safety-recalls-info-button'
                }`}
            >
                <div className="recalls-info-button-content">
                    <div className="recalls-info-button-title">
                        {recallsToLowerCase(
                            recall.descriptionLang,
                            props.exemptWordsList
                        )}
                    </div>
                    {!isCsp && (
                        <div className="recalls-info-button-labels">
                            {content.recallIncompleteLabel}
                        </div>
                    )}
                </div>
                <img
                    className="recalls-info-button-arrow-img"
                    src={arrowRight}
                    alt=""
                    height={24}
                    width={24}
                    loading="lazy"
                />
            </div>
        </button>
    );
};

export default RecallsButton;
